import { lazy } from 'react';
import { Settings } from 'lucide-react';
import type { FeatureSection } from './registry';
import { operationsSection } from '@/features/operations/section';
import { customersSection } from '@/features/customers/section';
import { marketsSection } from '@/features/markets/section';
import { plansSection } from '@/features/plans/section';
import { maintenanceSection } from '@/features/maintenance/section';
import { mechSection } from '@/features/mech/section';

/**
 * The console's information architecture. Each feature module owns its routes; a route is
 * visible when its permission resource is readable (gateway rule: write implies read).
 */
export const sections: FeatureSection[] = [
  operationsSection,
  customersSection,
  marketsSection,
  plansSection,
  maintenanceSection,
  mechSection,
  {
    key: 'platform',
    title: 'platform',
    icon: Settings,
    routes: [
      {
        path: '/platform/admins',
        title: 'admins',
        tabs: [
          { key: 'admins', title: 'admins', resource: 'admin', component: lazy(() => import('@/features/platform/admins/AdminsPage')) },
          {
            key: 'service-accounts',
            title: 'serviceAccounts',
            resource: 'admin',
            legacyPath: '/platform/service-accounts',
            component: lazy(() => import('@/features/platform/service-accounts/ServiceAccountsPage')),
          },
        ],
      },
      { path: '/platform/roles', title: 'rolesPermissions', resource: 'role', component: lazy(() => import('@/features/platform/roles/RolesPage')) },
      { path: '/platform/deeplinks', title: 'deeplinks', resource: 'deeplink', component: lazy(() => import('@/features/platform/deeplinks/DeeplinksPage')) },
      { path: '/platform/config', title: 'remoteConfig', resource: 'ferra', component: lazy(() => import('@/features/platform/config/ConfigPage')) },
      { path: '/platform/ota', title: 'otaCampaigns', resource: 'ota', component: lazy(() => import('@/features/platform/ota/OtaCampaignsPage')) },
      {
        path: '/platform/ota/:campaignId',
        title: 'otaCampaign',
        resource: 'ota',
        hideInMenu: true,
        component: lazy(() => import('@/features/platform/ota/OtaCampaignPage')),
      },
    ],
  },
];
